import { z } from 'zod/v3';

export const EffectiveRequirementScopeSourceSchema = z.enum([
  'MANUAL',
  'AUTO_RULE',
  'DEFAULT',
]);
export type EffectiveRequirementScopeSource = z.infer<
  typeof EffectiveRequirementScopeSourceSchema
>;

export const RequirementApplicabilitySchema = z.enum([
  'APPLICABLE',
  'NOT_APPLICABLE',
]);
export type RequirementApplicability = z.infer<
  typeof RequirementApplicabilitySchema
>;

export const FrameworkRequirementScopeDTOSchema = z
  .object({
    frameworkDefId: z.string(),
    frameworkControlId: z.string(),
    applicability: RequirementApplicabilitySchema,
    source: EffectiveRequirementScopeSourceSchema,
    reason: z.string().nullable(),
    ruleKey: z.string().nullable(),
    decidedByUserId: z.string().nullable(),
    decidedAt: z.string().datetime().nullable(),
  })
  .strict();
export type FrameworkRequirementScopeDTO = z.infer<
  typeof FrameworkRequirementScopeDTOSchema
>;

const RequirementScopeTargetSchema = z.object({
  programId: z.string().min(1),
  frameworkDefId: z.string().min(1),
  frameworkControlId: z.string().min(1),
});

export const MarkRequirementScopeInputSchema = RequirementScopeTargetSchema.extend({
  reason: z.string().trim().min(1).max(4000),
});
export type MarkRequirementScopeInput = z.infer<
  typeof MarkRequirementScopeInputSchema
>;

export const ResetRequirementScopeInputSchema = RequirementScopeTargetSchema;
export type ResetRequirementScopeInput = z.infer<
  typeof ResetRequirementScopeInputSchema
>;
